export const CLASS_NAME = 'digital-print-specification';
export const METHOD = 'method';
export const PAGES = 'printedPages';
